module.exports = __webpack_public_path__ + "static/business_consulting-e87e1557ff4878e69b351c0751a89108.jpg";